module.exports = __webpack_public_path__ + "img/Sebastien.3d34ac3e.jpeg";